// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ebbd72225cb4ee0121ba","655":"5eeacf8587e8e8d0b59a"}[chunkId] + ".js";
};